import React from 'react';
export function Footer() {
  return <footer className="bg-background py-8 border-t border-border" data-id="element-84">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-85">
        <div className="text-xl font-semibold tracking-tight text-primary" data-id="element-86">
          Юридичний захист / Юридична компанія
        </div>

        <div className="flex gap-6 text-sm text-secondary" data-id="element-87">
          <a href="#" className="hover:text-primary transition-colors" data-id="element-88">
            Telegram
          </a>
          <a href="#" className="hover:text-primary transition-colors" data-id="element-89">
            Viber
          </a>
          <a href="#" className="hover:text-primary transition-colors" data-id="element-90">
            Facebook
          </a>
        </div>

        <div className="text-sm text-secondary" data-id="element-91">
          &copy; 2026 Всі права захищені.
        </div>
      </div>
    </footer>;
}